import {gql} from 'apollo-angular';

export const GET_CLICK_PIC_POINTS = gql`
  query GetClickThePicPointSteps($gameId: Int!) {
    getClickThePicPointSteps(gameID: $gameId)
  }
`;
